import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import logodti from '../../assets/Img/dti-white.png';

const Logo: React.FC = () => {
  const profileId = useSelector((state: any) => state.auth.profileId);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: { xs: 'right', sm: 'flex-start' },
        alignItems: 'center',
        flexGrow: 1,
      }}
    >
      <Typography
        variant="h5"
        noWrap
        component="a"
        href={
          profileId === 1 ? '/homeAdm' : profileId === 2 ? '/home-user' : '/'
        }
        sx={{
          display: 'flex',
          alignItems: 'center',
          textDecoration: 'none',
          padding: { xs: '8px 12px', sm: '10px 16px' },
          borderRadius: '12px',
          backdropFilter: 'blur(8px)',
          marginLeft: { xs: '0', sm: '1rem', md: '2rem', lg: '3rem' },
          marginRight: { xs: '0', sm: '1rem' },
          position: 'relative',
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          cursor: 'pointer',
          userSelect: 'none',

          // Shimmer effect
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background:
              'linear-gradient(45deg, transparent 30%, rgba(255,255,255,0.1) 50%, transparent 70%)',
            transform: 'translateX(-100%)',
            transition: 'transform 0.6s ease',
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            gap: { xs: '8px', sm: '12px' },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px',
              borderRadius: '8px',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(4px)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            <img
              src={logodti}
              alt="DTI Logo"
              style={{
                height: '32px',
                width: 'auto',
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.1))',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            />
          </Box>

          <Typography
            className="logo-text"
            sx={{
              fontFamily: 'Roboto-Bold',
              fontSize: { xs: '12pt', sm: '13pt', md: '14pt' },
              color: '#ffffff',
              letterSpacing: '0.5px',
              textShadow: '0 1px 2px rgba(0,0,0,0.2)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              position: 'relative',
              zIndex: 2,
              background: 'linear-gradient(135deg, #ffffff 0%, #f1f5f9 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              '@supports not (background-clip: text)': {
                background: 'none',
                WebkitBackgroundClip: 'initial',
                WebkitTextFillColor: 'initial',
                color: '#ffffff',
              },
            }}
          >
            DTI
          </Typography>
        </Box>

        {/* Decorative elements */}
        <Box
          sx={{
            position: 'absolute',
            top: '2px',
            right: '2px',
            width: '4px',
            height: '4px',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            borderRadius: '50%',
            zIndex: 2,
            opacity: 0.8,
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            bottom: '2px',
            left: '2px',
            width: '3px',
            height: '3px',
            background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
            borderRadius: '50%',
            zIndex: 2,
            opacity: 0.6,
          }}
        />
      </Typography>
    </Box>
  );
};

export default Logo;
